import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const PromoactionLazy = loadable(() => import(/* webpackChunkName: "Promoactions" */ './PromoactionSuspense'));

export const PromoactionAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <PromoactionLazy />
    </DelayedSuspense>
);
